import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.public');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-public',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.public/view.scss */
:host {
  display: flex;
  min-height: 100%;
  width: 100%;
}

.public-shell {
  --ink: #102623;
  --muted: #667773;
  --line: rgba(16, 38, 35, 0.12);
  --green: #0f6b5a;
  --green-dark: #0a453c;
  background: #f7f9f6;
  color: var(--ink);
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
}

.public-header {
  backdrop-filter: blur(18px);
  background: rgba(247, 249, 246, 0.88);
  border-bottom: 1px solid rgba(16, 38, 35, 0.08);
  position: sticky;
  top: 0;
  z-index: 40;
}

.public-header__inner {
  align-items: center;
  display: flex;
  height: 76px;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1320px;
  padding: 0 32px;
  position: relative;
}

.public-brand {
  align-items: center;
  background: transparent;
  border: 0;
  display: inline-flex;
  gap: 12px;
  padding: 4px 0;
}

.public-brand__logo {
  display: block;
  height: 50px;
  user-select: none;
  width: auto;
}

.public-nav {
  align-items: center;
  display: flex;
  gap: 4px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}

.public-nav__item {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 999px;
  color: #52635f;
  display: inline-flex;
  font-size: 13px;
  font-weight: 650;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  transition: background 180ms ease, color 180ms ease;
  white-space: nowrap;
}

.public-nav__item:hover,
.public-nav__item.is-active {
  background: #eaf2ed;
  color: var(--green-dark);
}

.public-nav__item svg {
  height: 16px;
  width: 16px;
}

.public-nav__service svg {
  transition: transform 180ms ease;
}

.public-nav__service.is-active svg {
  transform: rotate(180deg);
}

.public-nav__external {
  text-decoration: none;
}

.service-dropdown {
  animation: dropdown-in 180ms cubic-bezier(0.2, 0.75, 0.25, 1);
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(16, 38, 35, 0.1);
  border-radius: 18px;
  box-shadow: 0 22px 56px rgba(16, 38, 35, 0.16);
  left: -18px;
  padding: 8px;
  position: absolute;
  top: 50px;
  width: 326px;
}

.service-dropdown::before {
  bottom: 100%;
  content: "";
  height: 14px;
  left: 0;
  position: absolute;
  right: 0;
}

.service-dropdown__item {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 13px;
  color: var(--ink);
  display: grid;
  gap: 12px;
  grid-template-columns: 42px minmax(0, 1fr) 20px;
  padding: 12px;
  text-align: left;
  text-decoration: none;
  transition: background 160ms ease, transform 160ms ease;
  width: 100%;
}

.service-dropdown__item:hover {
  background: #f1f6f3;
  transform: translateX(2px);
}

.service-dropdown__icon {
  align-items: center;
  border-radius: 12px;
  display: flex;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.service-dropdown__icon svg {
  height: 22px;
  width: 22px;
}

.service-dropdown__icon--manage {
  background: #e1f4e9;
  color: #0f6b5a;
}

.service-dropdown__icon--market {
  background: #e8ecf7;
  color: #253b67;
}

.service-dropdown__item > span:nth-child(2) {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.service-dropdown__item strong {
  font-size: 13px;
  font-weight: 750;
}

.service-dropdown__item small {
  color: #75847f;
  font-size: 11px;
}

.service-dropdown__arrow {
  color: #81908c;
  height: 18px;
  width: 18px;
}

.public-header__actions {
  align-items: center;
  display: flex;
  gap: 10px;
}

.public-header__consult {
  background: var(--ink);
  border: 0;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  height: 40px;
  padding: 0 18px;
  transition: background 180ms ease, transform 180ms ease;
}

.public-header__consult:hover {
  background: var(--green-dark);
  transform: translateY(-1px);
}

.mobile-menu-button {
  align-items: center;
  background: transparent;
  border: 1px solid var(--line);
  border-radius: 10px;
  display: none;
  flex-direction: column;
  gap: 4px;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.mobile-menu-button span {
  background: var(--ink);
  border-radius: 99px;
  height: 1.5px;
  transition: transform 180ms ease, opacity 180ms ease;
  width: 17px;
}

.mobile-menu-button.is-active span:nth-child(1) {
  transform: translateY(5.5px) rotate(45deg);
}

.mobile-menu-button.is-active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-button.is-active span:nth-child(3) {
  transform: translateY(-5.5px) rotate(-45deg);
}

.mobile-menu {
  animation: mobile-menu-in 180ms ease-out;
  background: rgba(247, 249, 246, 0.98);
  border-top: 1px solid var(--line);
  display: none;
  padding: 12px 20px 18px;
}

.mobile-menu button,
.mobile-menu a {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 12px;
  color: var(--ink);
  display: flex;
  font-size: 14px;
  font-weight: 650;
  justify-content: space-between;
  padding: 13px 12px;
  text-align: left;
  text-decoration: none;
  width: 100%;
}

.mobile-menu button:hover,
.mobile-menu a:hover {
  background: #eaf2ed;
}

.mobile-menu svg {
  height: 18px;
  width: 18px;
}

.public-main {
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
}

.public-footer {
  background: #f7f9f6;
  border-top: 1px solid rgba(16, 38, 35, 0.09);
}

.public-footer__inner {
  align-items: center;
  color: #73817d;
  display: flex;
  font-size: 11px;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1320px;
  min-height: 62px;
  padding: 12px 32px;
}

.public-footer__brand {
  align-items: center;
  display: flex;
  gap: 9px;
}

.public-footer__brand strong {
  color: #3a4e49;
  font-size: 11px;
  letter-spacing: 0.08em;
}

.public-footer__dot {
  background: #35a578;
  border-radius: 50%;
  height: 7px;
  width: 7px;
}

.public-loading {
  align-items: center;
  backdrop-filter: blur(8px);
  background: rgba(247, 249, 246, 0.75);
  display: flex;
  inset: 0;
  justify-content: center;
  position: fixed;
  z-index: 80;
}

button:focus-visible,
a:focus-visible {
  outline: 3px solid rgba(15, 107, 90, 0.28);
  outline-offset: 3px;
}

@keyframes dropdown-in {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes mobile-menu-in {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 980px) {
  .public-nav {
    display: none;
  }
  .public-header__consult {
    display: none;
  }
  .mobile-menu-button,
  .mobile-menu {
    display: flex;
  }
  .mobile-menu {
    flex-direction: column;
  }
}
@media (max-width: 640px) {
  .public-header__inner {
    height: 68px;
    padding: 0 20px;
  }
  .public-brand__logo {
    height: 44px;
  }
  .public-footer__inner {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
    padding: 18px 20px;
  }
  .public-footer__brand > span:last-child {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}`],
})
export class LayoutPublicComponent implements OnInit {
    public menuOpen: boolean = false;
    public serviceMenuOpen: boolean = false;
    public currentYear: number = new Date().getFullYear();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    @HostListener('document:click')
    public async closeDropdowns() {
        if (!this.menuOpen && !this.serviceMenuOpen) return;
        this.menuOpen = false;
        this.serviceMenuOpen = false;
        await this.service.render();
    }

    @HostListener('document:keydown.escape')
    public async closeOnEscape() {
        const triggerId = this.menuOpen
            ? 'mobile-menu-trigger'
            : (this.serviceMenuOpen ? 'service-menu-trigger' : '');

        if (!triggerId) return;

        this.menuOpen = false;
        this.serviceMenuOpen = false;
        await this.service.render();

        const trigger = document.getElementById(triggerId) as HTMLElement;
        if (trigger) trigger.focus();
    }

    public async toggleServiceMenu(event: any) {
        event.stopPropagation();
        this.serviceMenuOpen = !this.serviceMenuOpen;
        this.menuOpen = false;
        await this.service.render();
    }

    public async toggleMenu(event: any) {
        event.stopPropagation();
        this.menuOpen = !this.menuOpen;
        this.serviceMenuOpen = false;
        await this.service.render();
    }

    public async goHome(event?: any) {
        if (event) event.stopPropagation();
        this.menuOpen = false;
        this.serviceMenuOpen = false;
        await this.service.render();
        this.service.href('/home');
    }

    public async goManagement(event?: any) {
        if (event) event.stopPropagation();
        this.menuOpen = false;
        this.serviceMenuOpen = false;
        await this.service.render();
        this.service.href('/ip-management');
    }

    public async goConsultation(event?: any) {
        if (event) event.stopPropagation();
        this.menuOpen = false;
        this.serviceMenuOpen = false;
        await this.service.render();

        if (location.pathname === '/ip-management') {
            location.hash = 'consultation';
            return;
        }

        this.service.href('/ip-management#consultation');
    }

    public isManagementPage() {
        return location.pathname === '/ip-management';
    }
}

export default LayoutPublicComponent;